import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import funeraria01 from "../assets/images/funeraria01.jpg";
import funeraria02 from "../assets/images/funeraria02.jpg";
import funeraria04 from "../assets/images/funeraria04.jpeg";
import floricultura01 from "../assets/images/floricultura01.jpeg";
import funeraria05 from "../assets/images/funeraria05.jpeg";
import funerariaBanner from "../assets/images/funeraria-banner.jpg";
import { FaClock, FaMap, FaUserMd, FaLeaf, FaFileAlt, FaHandHoldingHeart, FaHeart, FaFire, FaFan } from 'react-icons/fa';

const FunerariaContainer = styled.div`
  color: #fff;
  background: #1A365D;
  padding: 100px 0;

  @media screen and (max-width: 768px) {
    padding: 70px 0;
  }
`;

const FunerariaWrapper = styled.div`
  display: grid;
  z-index: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  grid-template-columns: 1fr 1fr;
  grid-gap: 50px;
  justify-content: center;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FunerariaContent = styled.div`
  max-width: 540px;
  padding-top: 0;
  padding-bottom: 60px;

  @media screen and (max-width: 768px) {
    padding-bottom: 30px;
  }
`;

const FunerariaServicesWrapper = styled.div`
  display: grid;
  z-index: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  grid-template-columns: 1fr;
  grid-gap: 50px;
  justify-content: center;
`;

const FunerariaServicesContent = styled.div`
  padding-top: 0;
  padding-bottom: 60px;

  @media screen and (max-width: 768px) {
    padding-bottom: 30px;
  }
`;

const TopLine = styled(motion.p)`
  color: #4CAF50;
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;
  font-family: 'Open Sans', sans-serif;
`;

const Heading = styled(motion.h2)`
  margin-bottom: 24px;
  font-size: 40px;
  line-height: 1.1;
  font-weight: 600;
  color: #fff;
  font-family: 'Playfair Display', serif;

  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`;

const Subtitle = styled(motion.p)`
  margin-bottom: 35px;
  font-size: 18px;
  line-height: 24px;
  color: #fff;
  font-family: 'Open Sans', sans-serif;
`;

const BtnWrap = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const Button = styled(motion.button)`
  border-radius: 4px;
  background: #4CAF50;
  white-space: nowrap;
  padding: 12px 30px;
  color: #fff;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  font-family: 'Open Sans', sans-serif;
  font-weight: bold;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #4CAF50;
  }
`;

const ImgWrap = styled.div`
  max-width: 555px;
  height: 100%;
`;

const ImgGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  max-width: 555px;
  margin-top: 50px;

  @media screen and (max-width: 768px) {
    margin-top: -30px;
  }
`;

const Img = styled(motion.img)`
  width: 100%;
  margin: 0 0 10px 0;
  padding-right: 0;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
`;

const Stats = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  margin-bottom: 30px;
`;

const StatItem = styled(motion.div)`
  text-align: center;
`;

const StatNumber = styled.h3`
  font-size: 36px;
  color: #4CAF50;
  margin-bottom: 5px;
  font-family: 'Playfair Display', serif;
`;

const StatText = styled.p`
  font-size: 14px;
  color: #fff;
  font-family: 'Open Sans', sans-serif;
`;

// Novo styled para a seção de serviços
const FullWidthContainer = styled.div`
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  background: #1A365D;
  padding: 70px 0 70px 0;
`;

const ServicesHeading = styled(Heading)`
  /*text-align: center;*/
`;

const ServicesGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;

  @media screen and (max-width: 900px) {
    gap: 16px;
  }
  @media screen and (max-width: 600px) {
    gap: 18px;
    margin-top: -30px;
  }
`;

const ServiceCard = styled(motion.div)`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 10px;
  padding: 20px;
  max-width: 150px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  position: relative;
  text-align: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:hover {
    transform: translateY(-6px) scale(1.04);
    box-shadow: 0 6px 18px rgba(0,0,0,0.18);
    background: #1A365D;
  }

  @media screen and (max-width: 600px) {
    max-width: 160px;
    min-height: 220px;
  }
`;

const ServiceIcon = styled.div`
  font-size: 2rem;
  color: #4CAF50;
  margin-bottom: 12px;
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: #1A365D;
`;

const Funeraria = () => {
  return (
    <FunerariaContainer id="funeraria">
      <FunerariaWrapper>
        <FunerariaContent>
          <TopLine
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Funerária
          </TopLine>
          <Heading
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Funerária São José
          </Heading>
          <Subtitle
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            Com mais de 30 anos de dedicação e compromisso, a Funerária São José construiu uma trajetória marcada pelo respeito, pela confiança e pelo cuidado com as famílias da região das Missões.
          </Subtitle>
          <Subtitle
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            Desde sua fundação, nosso propósito sempre foi oferecer muito mais do que um serviço: buscamos prestar apoio verdadeiro nos momentos mais delicados, com atenção, empatia e profissionalismo. Ao longo dessas mais de três décadas, nos consolidamos como referência no setor, sendo reconhecidos como a melhor funerária da região.          
          </Subtitle>
          <Subtitle
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            Com uma equipe preparada, estrutura adequada e atendimento humanizado, a Funerária São José se mantém firme em sua missão: servir com dignidade, respeito e acolhimento, sempre ao lado das famílias quando elas mais precisam.          
          </Subtitle>
          {/*<Stats>
            <StatItem
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              <StatNumber>1992</StatNumber>
              <StatText>Ano de Fundação</StatText>
            </StatItem>
            <StatItem
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.7 }}
            >
              <StatNumber>50mil</StatNumber>
              <StatText>m² de Área</StatText>
            </StatItem>
          </Stats>*/}
        </FunerariaContent>
        <ImgWrap>
          <ImgGrid>
            <Img
              src={funeraria01}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            />
          </ImgGrid>
        </ImgWrap>
      </FunerariaWrapper>
      {/* Nova Seção: Serviços Funerários */}
      <FullWidthContainer id="servicos-funerarios" style={{padding: '30px 0 0px 0'}}>
        <FunerariaWrapper>
          <FunerariaContent>
            <TopLine
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              Serviços
            </TopLine>
            <ServicesHeading
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              Serviços Funerários
            </ServicesHeading>
            <Subtitle
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              Com mais de 30 anos de tradição e excelência, a Funerária São José oferece um serviço funerário completo, com atendimento humanizado e estrutura preparada para atender com respeito e agilidade em todos os momentos.
            </Subtitle>
            <Subtitle
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              Somos referência em Santa Rosa e em toda a região das Missões, oferecendo assistência completa desde o primeiro contato até o pós-cerimonial.
            </Subtitle>
            <Subtitle
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 1.5 }}
            >
              Funerária São José – Tradição, respeito e acolhimento quando sua família mais precisa.
            </Subtitle>
            <Img
              src={funerariaBanner}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.3 }}
            />
          </FunerariaContent>
          <FunerariaContent>
            <ServicesGrid>
              <ServiceCard initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.6 }}>
                <ServiceIcon><FaClock /></ServiceIcon>
                Atendimento 24 horas
              </ServiceCard>
              <ServiceCard initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.7 }}>
                <ServiceIcon><FaMap /></ServiceIcon>
                Traslados para todo Brasil
              </ServiceCard>
              <ServiceCard initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.8 }}>
                <ServiceIcon><FaUserMd /></ServiceIcon>
                Equipe especializada (tanatopraxia)
              </ServiceCard>
              <ServiceCard initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.9 }}>
                <ServiceIcon><FaLeaf /></ServiceIcon>
                Organização completa de velórios e sepultamentos
              </ServiceCard>
              <ServiceCard initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 1.0 }}>
                <ServiceIcon><FaFileAlt /></ServiceIcon>
                Orientação e suporte documental
              </ServiceCard>
              <ServiceCard initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 1.1 }}>
                <ServiceIcon><FaHandHoldingHeart /></ServiceIcon>
                Planos funerários e convênios
              </ServiceCard>
              <ServiceCard initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 1.3 }}>
                <ServiceIcon><FaFan /></ServiceIcon>
                Floricultura Completa
              </ServiceCard>
              <ServiceCard initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 1.2 }}>
                <ServiceIcon><FaHeart /></ServiceIcon>
                Apoio às famílias com sensibilidade e respeito
              </ServiceCard>
              <ServiceCard initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 1.3 }} className="hide-mobile">
                <ServiceIcon><FaFire /></ServiceIcon>
                Cremação e Sepultamento
              </ServiceCard>
            </ServicesGrid>
          </FunerariaContent>
        </FunerariaWrapper>
      </FullWidthContainer>
    </FunerariaContainer>
  );
};

export default Funeraria;
